import { createContext, useContext, useReducer, ReactNode } from 'react'

// 登录参数类型定义
interface LoginParams {
  onOk?: () => void
  [key: string]: any
}

// 登录状态类型定义
interface LoginState {
  showLoginModal: boolean
  params: LoginParams
}

// 登录动作类型
type LoginAction = { type: 'SHOW_LOGIN_MODAL'; params?: LoginParams } | { type: 'HIDE_LOGIN_MODAL' }

// 初始状态
const initialState: LoginState = {
  showLoginModal: false,
  params: {}
}

// Reducer
const loginReducer = (state: LoginState, action: LoginAction): LoginState => {
  switch (action.type) {
    case 'SHOW_LOGIN_MODAL':
      return {
        ...state,
        showLoginModal: true,
        params: action.params || {}
      }
    case 'HIDE_LOGIN_MODAL':
      return {
        ...state,
        showLoginModal: false,
        params: {}
      }
    default:
      return state
  }
}

// Context
const LoginContext = createContext<{
  state: LoginState
  dispatch: React.Dispatch<LoginAction>
} | null>(null)

// Provider组件
export const LoginProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(loginReducer, initialState)

  return <LoginContext.Provider value={{ state, dispatch }}>{children}</LoginContext.Provider>
}

// Hook
export const useLoginContext = () => {
  const context = useContext(LoginContext)
  if (!context) {
    throw new Error('useLoginContext must be used within a LoginProvider')
  }
  return context
}

// 便捷的Hook
export const useLoginModal = () => {
  const { state, dispatch } = useLoginContext()

  const showLoginModal = (params?: LoginParams) => {
    dispatch({ type: 'SHOW_LOGIN_MODAL', params })
  }

  const hideLoginModal = () => {
    dispatch({ type: 'HIDE_LOGIN_MODAL' })
  }

  return {
    showLoginModal,
    hideLoginModal,
    isLoginModalVisible: state.showLoginModal,
    params: state.params
  }
}
